/* global __GIT_COMMIT_SHA__ */
import { isReview, isStaging, getCanonicalUrl } from "common/utils/env";
import { datadogRum } from "@datadog/browser-rum";
import { isCrawler } from "common/utils/browser";

const nodeEnv = process.env.NODE_ENV;
const version =
  typeof __GIT_COMMIT_SHA__ !== "undefined" && __GIT_COMMIT_SHA__.length > 0
    ? __GIT_COMMIT_SHA__
    : undefined;

if (nodeEnv !== "test" && nodeEnv !== "development") {
  let environment;

  if (isStaging()) {
    environment = "staging";
  } else if (isReview()) {
    environment = "review";
  } else {
    environment = "production";
  }

  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isBotTraffic = isCrawler(userAgent);
  const NOISE_RESOURCE_URL_PATTERN = /^(chrome|edge|moz|safari)-extension:|^about:|^data:|^blob:/i;

  if (!isBotTraffic) {
    datadogRum.init({
      applicationId: "7a00a52b-fc11-4bad-96ee-4311cc46cdc8",
      clientToken: "pubaa0f44eb7916427ef0e13a746ab85fdc",
      site: "datadoghq.com",
      service: "jiffy-web",
      version,
      env: environment,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 5,
      trackBfcacheViews: true,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [
        "https://jiffy.com",
        "https://www.jiffy.com",
        "https://staging.sdtechdev.com",
        /^https:\/\/[^\/]+.\.staging\.sdtechdev\.com/ // eslint-disable-line
      ],
      beforeSend: event => {
        // The top level isBotTraffic filter should prevent all bot traffic from being sent to Datadog, but in the case
        // it slips past that for any reason, this is a defensive safeguard to filter out a layer deeper.
        if (isBotTraffic) {
          return false;
        }

        if (event.type === "resource") {
          const resourceUrl = event.resource?.url || "";
          // Drop resource events that originate from browser extensions or inline-only URLs.
          // These do not reflect our site performance and can add noisy data volume.
          if (NOISE_RESOURCE_URL_PATTERN.test(resourceUrl)) {
            return false;
          }
        }

        return true;
      }
    });

    if (isReview()) {
      const reviewEnv = getCanonicalUrl().split(".")[0].split("//")[1];
      datadogRum.setGlobalContext({
        review: reviewEnv
      });
    }
  }
}
